import React from 'react';
import { Space } from 'antd';
import TriangleIcon from 'components/IconAntDesign/TriangleIcon';
import _UserAvatarDummy_styled from './_styles/_UserAvatarDummy_styled';
import _UserAvatar_styled from './_styles/_UserAvatar_styled';

const _Page_Header_User_Name = ({ user, self }) => {
  const isViewAs = self.auser_id !== user.auser_id;
  const userInitials = user.first_name && user.last_name
    ? `${user.first_name[0]}${user.last_name[0]}`.toUpperCase()
    : user.display_name?.slice(0, 2).toUpperCase();

  let UserAvatar = null;

  if (user.avatar?.uri) {
    UserAvatar = (
      <_UserAvatar_styled
        src={user.avatar.uri}
        alt={userInitials}
        isViewAs={isViewAs}
      />
    )
  }
  else {
    UserAvatar = (
      <_UserAvatarDummy_styled
        isViewAs={isViewAs}
      >
      {userInitials}
      </_UserAvatarDummy_styled>
    )
  }

  return (
    <Space style={{ alignItems: 'center', display: 'flex' }}>
      <span css={`
        display: none;

        @media (min-width: ${p => p.theme.tabletSize}) {
          display: inline;
        }
      `}>{user.display_name}</span>
      {UserAvatar}
      <TriangleIcon css={`
        vertical-align: middle;
      `}/>
    </Space>
  );
};

export default _Page_Header_User_Name;
